import React from "react";
import { Formik } from "formik";
import { observer } from 'mobx-react';
import * as Yup from "yup";
import {
    Radio,
    RadioGroup,
    FormControlLabel,
    FormControl,
    Button,
    CircularProgress,
    TextField,
    InputAdornment,
} from "@material-ui/core";
import RolesDropdown from "../RolesDropdown";


const InviteByLinkForm = ({ activeUsers, roles, onSubmit, onRoleCreate, onRoleEdit, onRoleDelete, store, loadingRoles }) => {
    const defaultRole = roles.find(role => role.name == "Standard Users");

    return (
        <Formik
            initialValues={{ type: "ANY_EMAIL", role_id: defaultRole?.id || "" }}
            onSubmit={async (values, { resetForm }) => {
                console.log(values);
                const resp = await onSubmit(values);
                if (resp) {
                    resetForm();
                }
            }}
            validationSchema={
                Yup.object().shape({
                    domain: Yup.string()
                        .when('type', {
                            is: 'SPECIFIC_DOMAIN',
                            then: Yup.string().trim()
                                .matches(/(?=^.{4,253}$)(^((?!-)[a-zA-Z0-9-]{1,63}([^-]?)\.)+[a-zA-Z]{2,63}$)/)
                                .required('Domain is required.'),
                        })
                })
            }
        >
            {
                props => {
                    const {
                        values,
                        touched,
                        errors,
                        dirty,
                        isSubmitting,
                        handleChange,
                        handleBlur,
                        handleSubmit,
                        handleReset
                    } = props;
                    return (
                        <form onSubmit={handleSubmit}>
                            <div style={{ display: 'flex', paddingTop: 10, alignItems: 'center' }}>
                                <div>Create an invite link that grants</div>
                                <div style={{ display: 'flex', flexDirection: 'column', padding: "0px 10px" }}>
                                    <RolesDropdown
                                        value={values.role_id}
                                        handleChange={handleChange}
                                        roles={roles}
                                        onRoleCreate={onRoleCreate}
                                        onRoleDelete={onRoleDelete}
                                        loadingRoles={loadingRoles}
                                    />
                                </div>
                                <div>access to anyone who opens it.</div>
                            </div>
                            <div>
                                <FormControl component="fieldset">
                                    <RadioGroup name="type" value={values.type} onChange={handleChange}>
                                        <FormControlLabel value="ANY_EMAIL" control={<Radio />} label="Allow any email address" />
                                        <FormControlLabel value="SPECIFIC_DOMAIN" control={<Radio />}
                                            label={
                                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                                    Allow Only
                                                    <TextField
                                                        name="domain"
                                                        value={values.domain}
                                                        disabled={values.type != "SPECIFIC_DOMAIN"}
                                                        onChange={handleChange}
                                                        variant="outlined"
                                                        style={{ margin: "0 5px" }}
                                                        InputProps={{
                                                            startAdornment: (
                                                                <InputAdornment position="start">
                                                                    @
                                                                </InputAdornment>
                                                            ),
                                                        }}
                                                    />
                                                    email addresses
                                                </div>
                                            }
                                        />
                                    </RadioGroup>
                                </FormControl>
                            </div>
                            <Button
                                variant="contained"
                                type="submit"
                                style={{ marginTop: 10 }}
                                disabled={isSubmitting || Object.keys(errors).length > 0}>
                                Create Link &nbsp; {isSubmitting && <CircularProgress size={20} />}
                            </Button>
                        </form>
                    );
                }
            }
        </Formik>
    );
}

export default observer(InviteByLinkForm);